import { createSelector } from 'reselect';
import { getCurrentYearRedemptions } from '../transactionHistory/transactionHistory.selectors';
import { ApplicationState } from '../types';
import { getUserAddress } from '../user/PersonalInformation/personalInformation.selectors';
import { StateWithholdingSpec } from './types';

const getStateWithholding = ({ stateWithholding }: ApplicationState) =>
  stateWithholding;

/**
 * Simple selector to extract state withholding lookup by state code, returning empty object if not loaded yet.
 */
export const getWithholdingStateLookup = createSelector(
  getStateWithholding,
  ({ stateLookup = {} }) => stateLookup
);

// Simple selector to extract state withholding data, returning empty array if not loaded yet.
export const getWithholdingStateData = createSelector(
  getStateWithholding,
  ({ withholdingData = [] }) => withholdingData
);

/**
 * Subset of state withholdings for the mandatory withholding states.
 */
export const getMandatoryWithholdingStates = createSelector(
  getWithholdingStateData,
  (stateData) => {
    return stateData
      ?.filter(({ mandatory }) => !!mandatory)
      ?.map(({ stateCode }) => stateCode);
  }
);

export const isInMandatoryWithholdingState = createSelector(
  [getMandatoryWithholdingStates, getUserAddress],
  (mandatoryWithholdingStates, userAddress) =>
    userAddress?.state &&
    mandatoryWithholdingStates?.includes(userAddress?.state)
);
/**
 * Subset of state withholdings for the non-mandatory withholding states.
 */
export const getNonMandatoryWithholdingStates = createSelector(
  getWithholdingStateData,
  (stateData) => {
    return stateData
      ?.filter(({ mandatory }) => !mandatory)
      ?.map(({ stateCode }) => stateCode);
  }
);

export const getUserStateWithholdingRules = createSelector(
  getCurrentYearRedemptions,
  getWithholdingStateLookup,
  (currentYearRedemptionTotal, stateLookup) => {
    /*TEST123*/
    return {
      ...stateLookup,
      redemptionTotal: currentYearRedemptionTotal || 0,
    } as StateWithholdingSpec & { redemptionTotal: number };
  }
);
